import { render, staticRenderFns } from "./zpgwxq.vue?vue&type=template&id=22c66845&scoped=true&"
import script from "./zpgwxq.vue?vue&type=script&lang=js&"
export * from "./zpgwxq.vue?vue&type=script&lang=js&"
import style0 from "./zpgwxq.vue?vue&type=style&index=0&id=22c66845&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c66845",
  null
  
)

export default component.exports